var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatingArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "M1.92 19.028h11.532v-3.685H1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.258 15.343H3.767V9.997c0-.69.558-1.25 1.248-1.25h5.995c.69 0 1.248.56 1.248 1.25v5.346z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.258 15.343H3.767V9.997c0-.69.558-1.25 1.248-1.25h5.995c.69 0 1.248.56 1.248 1.25v5.346z",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.612 19.028H1.92v-5.173c0-.698.566-1.265 1.264-1.265h1.164c.698 0 1.264.567 1.264 1.265v5.173z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.612 19.028H1.92v-5.173c0-.698.566-1.265 1.264-1.265h1.164c.698 0 1.264.567 1.264 1.265v5.173z",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.015 19.028h-3.693v-5.173c0-.698.565-1.265 1.263-1.265h1.165c.698 0 1.265.567 1.265 1.265v5.173z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.015 19.028h-3.693v-5.173c0-.698.565-1.265 1.263-1.265h1.165c.698 0 1.265.567 1.265 1.265v5.173z",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.624 6.382c.252.953-.351 1.726-1.335 1.726h-1.887c-.99 0-1.586-.776-1.335-1.726l.033-.126c.252-.953 1.25-1.726 2.246-1.726.988 0 1.994.776 2.245 1.726l.033.126z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "M22.08 8.108h-5.47l.947-3.578h3.578z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.346 8.108v11.454"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "M19.346 8.108v11.454"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.466 19.186h3.606V17.63h-3.606z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    fill: "#666",
    d: "M17.466 19.186h3.606V17.63h-3.606z"
  }))));
}
export default SvgSeatingArea;